
export default {
  filters: [], 
  userProfile: {isAuthenticated: false, token: '', user: {}},
  appStatus: {loading: null,fileType: 'xlsx'},
  dashboardStatus : {salesType: null, monthHorizon: null},
}
